import { openEliteLandingPage, trackEvent } from '../../../../utils/appBridge'
import { EventNames, type ElitePlanOfferType } from '../../../../types/misc.types'
import PrimaryButton from '../../../ui-components/PrimaryButton'
import TimeSegment from './TimeSegment'
import { monthLookup } from '../../../../utils/utils'
import { CountdownTime } from '../../../../types/rebalance'
import { EliteOfferBanner } from '../../../elite/landing-page/versions/landing-page-head/EliteOfferBanner'
import { useAppMetaContent } from '../../../../state-management/providers/AppMetaContentProvider'

// Helper to safely fetch month long name
export const getMonthLong = (monthNum: number, fallback: string) => {
  const m = (monthLookup as any)?.[String(monthNum)]?.long
  return m || fallback
}

const CountdownView = ({
  time,
  firstPlanMonth,
  nextPlanMonth,
  isUserElite = false,
  specialOffering,
  signupOffer,
  offerStartTime,
  offerExpiryTime,
  offerType,
  membershipFees
}: {
  time: CountdownTime
  firstPlanMonth: number
  nextPlanMonth?: number
  isUserElite: boolean
  specialOffering?: boolean
  signupOffer?: boolean
  offerStartTime?: number | null
  offerExpiryTime?: number | null
  offerType?: ElitePlanOfferType | null
  membershipFees?: number
}) => {
  const firstMonthName = firstPlanMonth ? getMonthLong(firstPlanMonth, 'Next') : 'Next'
  const nextMonthName = nextPlanMonth ? getMonthLong(nextPlanMonth, 'a future month') : 'a future month'
  const { getEliteMembersDisplay } = useAppMetaContent()
  return (
    <div className='text-brown-dark'>
      {isUserElite ? (
        <h2 className='text-[22px] text-orange10 text-left'>Your rebalancing plan drops in</h2>
      ) : (
        <h2
          className='text-[22px] text-orange10 text-left'
          aria-label='Reserve your rebalancing plan with Elite. Next rollout in'
        >
          {/* aria-hidden: emphasis span was a second TalkBack stop (same pattern as Reg_Power_Rebalancing_B03) */}
          <span aria-hidden='true'>
            Reserve your rebalancing plan with Elite. <span className='font-medium'>Next rollout in</span>
          </span>
        </h2>
      )}
      <div className='flex justify-evenly items-center bg-white rounded-2xl shadow-[2px_2px_0_0#CC5C2D] mb-6 mt-6'>
        <TimeSegment value={time.days} label='days' isFirst={true} />
        <TimeSegment value={time.hours} label='hours' />
        <TimeSegment value={time.minutes} label='minutes' />
        <TimeSegment value={time.seconds} label='seconds' />
      </div>
      {isUserElite ? (
        <p className='text-orange10 mb-3'>
          Your spot is reserved. We will notify you once your rebalancing plan is ready.
        </p>
      ) : (
        <>
          <p className='text-base text-orange10 text-left mb-8'>
            Know which funds to <span className='font-medium'>exit and switch to better-performing ones</span>, with
            your Power Rebalancing plan.
          </p>
          <EliteOfferBanner
            specialOffering={specialOffering ?? false}
            signupOffer={signupOffer ?? false}
            offerStartTime={offerStartTime}
            offerExpiryTime={offerExpiryTime}
            offerType={offerType}
            membershipFees={membershipFees ?? 0}
            source='CountdownView'
            screenType='MF_Smart_Rebalancing'
          />
          <div className='relative'>
            {/* <div className='absolute left-0 w-full h-full bg-[#ffffff] text-center z-[0] top-[-30px] rounded-xl'>
              <span className='text-orange10 text-13 text-center w-full'>
                {' '}
                Special price of ₹999/yr + GST till 21st Oct
              </span>
            </div> */}
            <PrimaryButton
              onClick={() => {
                trackEvent({
                  eventName: EventNames.UserClicked,
                  payload: {
                    eventId: 'ExploreEliteClicked',
                    ScreenName: 'CountdownView',
                    buttonLabel: 'Unlock Plan'
                  }
                })
                openEliteLandingPage()
              }}
              isFullWidth
              label='Unlock Plan'
              aria-label='Unlock Plan, double tap to unlock plan'
              labelClassName='text-white'
            />
          </div>
          <div className='text-13 text-orange10 mt-3 text-center'>Trusted by {getEliteMembersDisplay('short')} Elite members</div>
        </>
      )}
    </div>
  )
}

export default CountdownView
